import React from 'react'
import { useParams } from 'react-router-dom'
import TaskForm from './TaskForm'

const TaskView = () => {
  const { id } = useParams()

  return (
    <TaskForm 
      mode="view" 
      taskId={id}
    />
  )
}

export default TaskView

